import { searchHolidays } from '@lib/api'
import { holidayKeys } from '@lib/keys'
import { useQuery } from '@tanstack/react-query'
import { DateTime, Interval } from 'luxon'

interface Options {
  enabled?: boolean
  start: DateTime
  end: DateTime
  holidayCalendarId?: string | null
}

export const useHolidaysByCalendar = (options: Options) => {
  return useQuery(
    holidayKeys.search(options.holidayCalendarId ?? '', options.start, options.end),
    () => searchHolidays(options.holidayCalendarId ?? '', options.start, options.end),
    {
      enabled: Boolean(options.holidayCalendarId) && (options.enabled ?? true),
    },
  )
}

export const useHolidaysOnDate = (date: DateTime, options: Options) => {
  const { data } = useHolidaysByCalendar(options)

  if (!data) return []

  return data.filter(({ startDate, endDate }) =>
    Interval.fromDateTimes(startDate, endDate.endOf('day')).contains(date),
  )
}
